"use strict";

// Get a universally unique identifier
var count = 0;
module.exports = function uuid() {
  return "react-tabs-" + count++;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-tabs/lib/helpers/uuid.js
 ** module id = 622
 ** module chunks = 0
 **/